import { observer } from "mobx-react-lite";
import React from "react";

const AppBeta = () => {
  return (
    <div>
      <h2>Beta...</h2>
    </div>
  );
};

export default observer(AppBeta);
